import { message } from 'antd'

export const generateId = () => {
  if (Weaver.identifierPrefix === '') {
    return Weaver.Node.generateId()
  }
  else {
    let namespacedId = Weaver.Node.generateId().split(Weaver.identifierPrefix)
    return namespacedId[namespacedId.length - 1]
  }
}

export const showErrorMessage = (msg) => {
  message.error("Error occured saving node")
  console.error(msg)
}
